
import NGError from '../../../error/ngError';
import errorFactory from '../../../error/errorFactory';
import {
	WS_PROCESS_MESSAGE_IS_MALFORMED,
	WS_REQUEST_IS_MALFORMED,
} from '../../../error/websocket/errorTypes';
import { fromDTO, toDTO } from './mappers/membersMapper.js';
import { publishAndAwait } from '../../../app/coreSlice';

const associateAccountMember = async (accountCode, customerList) => {

	if (typeof accountCode === 'undefined' || typeof customerList === 'undefined') {
		throw errorFactory(WS_REQUEST_IS_MALFORMED);
	};

	const request = await publishAndAwait({
		destination: '/app/hello',
		body: {
			type: 'ACCOUNTS',
			subType: 'ASSOCIATE_CUSTOMER_ACCOUNT',
			message: {
				accountCode,
				customerList: customerList.map(toDTO),
			},
		},
	});

	const { processMessage, error } = request.response;

	if (!processMessage || !processMessage.customerList) {
		throw errorFactory(WS_PROCESS_MESSAGE_IS_MALFORMED);
	};

	if (error) {

		const {
			description,
			code,
			tag,
		} = processMessage;

		throw new NGError({
			message: description,
			code,
			tag,
		});
	};

	const members = processMessage.customerList
		.reduce((acc, member) => ({...acc, [member.customerCode]: fromDTO(member)}), {});

	return members;
};

export default associateAccountMember;